import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Routes
} from "react-router-dom";

import { useEffect } from "react";

import liff from "@line/liff";

import { HOME_DIR, VERSION_APP } from "./Utills/constants";

import Theme1Screen from "./Components/Main/Theme1";
import Theme2Screen from "./Components/Main/Theme2";
import Theme3Screen from "./Components/Main/Theme3";
import Theme4Screen from "./Components/Main/Theme4";
import Theme5Screen from "./Components/Main/Theme5";
import Theme6Screen from "./Components/Main/Theme6";
import Theme7Screen from "./Components/Main/Theme7";
import Theme8Screen from "./Components/Main/Theme8";
import Theme9Screen from "./Components/Main/Theme9";
import Theme10Screen from "./Components/Main/Theme10";
import Theme11Screen from "./Components/Main/Theme11";
import Theme12Screen from "./Components/Main/Theme12";
import Theme13Screen from "./Components/Main/Theme13";
import Theme14Screen from "./Components/Main/Theme14";
import Theme15Screen from "./Components/Main/Theme15";
import Theme16Screen from "./Components/Main/Theme16";
import Theme17Screen from "./Components/Main/Theme17";
import Theme18Screen from "./Components/Main/Theme18";
import Theme19Screen from "./Components/Main/Theme19";
import Theme20Screen from "./Components/Main/Theme20";
import Theme21Screen from "./Components/Main/Theme21";
import Theme22Screen from "./Components/Main/Theme22";
import Theme23Screen from "./Components/Main/Theme23";
import Theme24Screen from "./Components/Main/Theme24";
import Theme25Screen from "./Components/Main/Theme25";

function App() {

  useEffect(() => {
    document.title = `สุ่มกาชาปอง 99฿ ลุ้นรางวัลใหญ่ (v${VERSION_APP})`;
  }, []);

  useEffect(() => {

    liff.ready.then(() => {
      
    });
  }, []);
  return (
    <Router basename={`${HOME_DIR}`}>
      <Routes>
        {/* <Route exact path="/" element={<Theme1Screen />} /> */}
        {/* <Route exact path="/" element={<Theme2Screen />} /> */}
        {/* <Route exact path="/" element={<Theme3Screen />} /> */}
        {/* <Route exact path="/" element={<Theme4Screen />} /> */}
        <Route exact path="/" element={<Theme5Screen />} />
        {/* <Route exact path="/" element={<Theme6Screen />} /> */}
        {/* <Route exact path="/" element={<Theme7Screen />} /> */}
        {/* <Route exact path="/" element={<Theme8Screen />} /> */}
        {/* <Route exact path="/" element={<Theme9Screen />} /> */}
        {/* <Route exact path="/" element={<Theme10Screen />} /> */}
        {/* <Route exact path="/" element={<Theme11Screen />} /> */}
        {/* <Route exact path="/" element={<Theme12Screen />} /> */}
        {/* <Route exact path="/" element={<Theme13Screen />} /> */}
        {/* <Route exact path="/" element={<Theme14Screen />} /> */}
        {/* <Route exact path="/" element={<Theme15Screen />} /> */}
        {/* <Route exact path="/" element={<Theme16Screen />} /> */}
        {/* <Route exact path="/" element={<Theme17Screen />} /> */}
        {/* <Route exact path="/" element={<Theme18Screen />} /> */}
        {/* <Route exact path="/" element={<Theme19Screen />} /> */}
        {/* <Route exact path="/" element={<Theme20Screen />} /> */}
        {/* <Route exact path="/" element={<Theme21Screen />} /> */}
        {/* <Route exact path="/" element={<Theme22Screen />} /> */}
        {/* <Route exact path="/" element={<Theme23Screen />} /> */}
        {/* <Route exact path="/" element={<Theme24Screen />} /> */}
        {/* <Route exact path="/" element={<Theme25Screen />} /> */}
      </Routes>
    </Router>
  );
}

export default App;
